import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/DiscoveryToPayment.module.css';
import appMapviewImage from '../../assets/images/app_mapview.png';
import appSelectDateImage from '../../assets/images/app_select_date.png';
import appPaymentImage from '../../assets/images/app_payment.png';
import appPeriodicDateSelectImage from '../../assets/images/app_periodic_less_date_select.png';
import appPeriodicLessonImage from '../../assets/images/app_periodic_lesson_time_select.png';

// 예약 허들 흐름 (PT 슬라이드 4)
const bookingHurdleSteps = [
  {
    icon: '📱',
    label: 'SNS에서 센터 발견',
    description: '인스타그램, 유튜브 등'
  },
  {
    icon: '💬',
    label: '전화/카톡 상담으로 연결',
    description: '"문의 주세요" 클릭'
  },
  {
    icon: '😔',
    label: '나중에 해야지...',
    description: '일정 미루게 됨'
  }
];

// 올림 간편 예약 흐름 (PT 슬라이드 5)
const olympBookingSteps = [
  {
    icon: '🔍',
    label: '탐색',
    description: '센터 발견 & 비교'
  },
  {
    icon: '📅',
    label: '시간 선택',
    description: '원하는 날짜와 시간'
  },
  {
    icon: '💳',
    label: '결제',
    description: '바로 예약 완료'
  }
];

// 정기 레슨 혜택 (PT 슬라이드 6)
const regularLessonBenefits = [
  {
    icon: '📅',
    title: '요일과 시간 직접 선택',
    desc: '주 2회, 3회... 고객이 원하는 대로'
  },
  {
    icon: '🔄',
    title: '반복 일정 자동 생성',
    desc: '시작일만 선택하면 한 달 일정이 한번에'
  },
  {
    icon: '💳',
    title: '바로 결제까지 완료',
    desc: '상담 없이 앱에서 즉시'
  }
];

export default function DiscoveryToPayment() {
  const [ref1, isVisible1] = useScrollAnimation({ once: true });
  const [ref2, isVisible2] = useScrollAnimation({ once: true });
  const [ref3, isVisible3] = useScrollAnimation({ once: true });

  return (
    <>
      {/* 섹션 1: 예약 허들로 인한 고객 이탈 (PT 슬라이드 4) */}
      <section ref={ref1} className={`section ${styles.discoverySection}`}>
        <div className="section-content">
          <h2 className={`text-center ${styles.title}`}>
            예약 허들로 인한 <span className={styles.highlight}>고객 이탈</span>
          </h2>
          <p className={`text-center ${styles.subtitle}`}>
            마케팅을 통해 획득한 고객이 상담 허들로 인해 결제까지 가지 못합니다
          </p>

          <div className={`${styles.hurdleFlow} ${isVisible1 ? styles.visible : ''}`}>
            {bookingHurdleSteps.map((step, index) => (
              <div key={index} className={styles.hurdleStep}>
                <div className={styles.hurdleIcon}>{step.icon}</div>
                <div className={styles.hurdleLabel}>{step.label}</div>
                <div className={styles.hurdleDesc}>{step.description}</div>
                {index < bookingHurdleSteps.length - 1 && (
                  <div className={styles.hurdleArrow}>→</div>
                )}
              </div>
            ))}
          </div>

          <div className={`${styles.problemConclusion} ${isVisible1 ? styles.visible : ''}`}>
            <p className={styles.problemText}>
              고객은 전화, 카톡 상담에서 허들을 느끼고 일정을 미루게 됩니다
            </p>
            <p className={styles.problemHighlight}>
              <strong>상담 및 연락이 느릴수록 전환율은 급격히 떨어집니다</strong>
            </p>
          </div>

          {/* TODO: 수치적 근거 제시하는걸로 수정 */}
          {/* <div className={`${styles.quoteBox} ${isVisible1 ? styles.visible : ''}`}>
            <p className={styles.quote}>
              "다이빙 배우겠다고 마음먹고 검색했는데,<br />
              '카톡 상담 주세요'를 보고 일주일을 미뤘습니다.<br />
              저처럼 이탈하는 사람이 분명 있습니다."
            </p>
          </div> */}
        </div>
      </section>

      {/* 섹션 2: 상담 없이 원하는 시간에 바로 예약 (PT 슬라이드 5) */}
      <section ref={ref2} className={`section ${styles.solutionSection}`}>
        <div className="section-content">
          <h2 className={`text-center ${styles.title}`}>
            상담 없이, <span className={styles.highlight}>원하는 시간에 바로 예약</span>
          </h2>
          <p className={`text-center ${styles.subtitle}`}>
            올림에서는 탐색하고, 시간 선택하고, 바로 결제까지
          </p>

          <div className={`${styles.olympFlow} ${isVisible2 ? styles.visible : ''}`}>
            {olympBookingSteps.map((step, index) => (
              <div key={index} className={styles.olympStep}>
                <div className={styles.olympStepNumber}>{index + 1}</div>
                <div className={styles.olympIcon}>{step.icon}</div>
                <div className={styles.olympLabel}>{step.label}</div>
                <div className={styles.olympDesc}>{step.description}</div>
                {index < olympBookingSteps.length - 1 && (
                  <div className={styles.olympArrow}>→</div>
                )}
              </div>
            ))}
          </div>

          <div className={`${styles.phoneShowcase} ${isVisible2 ? styles.visible : ''}`}>
            <div className={styles.phoneMockup}>
              <img src={appMapviewImage} alt="센터 탐색 화면" />
            </div>
            <div className={styles.phoneMockup}>
              <img src={appSelectDateImage} alt="시간 선택 화면" />
            </div>
            <div className={styles.phoneMockup}>
              <img src={appPaymentImage} alt="결제 화면" />
            </div>
          </div>

          <div className={`${styles.solutionConclusion} ${isVisible2 ? styles.visible : ''}`}>
            <p className={styles.analogyText}>
              쇼핑몰이 간편결제를 도입한 것과 같은 전략입니다
            </p>
            <p className={styles.analogyHighlight}>
              <strong>고민할 시간이 길어질수록 빠져나갈 확률도 높아지기 때문입니다</strong>
            </p>
          </div>
        </div>
      </section>

      {/* 섹션 3: 정기 레슨도 올림에서 (PT 슬라이드 6) */}
      <section ref={ref3} className={`section ${styles.regularLessonSection}`}>
        <div className="section-content">
          <h2 className={`text-center ${styles.title}`}>
            주 2회, 3회 <span className={styles.highlight}>정기 레슨도 올림에서</span>
          </h2>
          <p className={`text-center ${styles.subtitle}`}>
            일일 대관이나 원데이 클래스만 앱으로 예약받으시나요?<br />
            정기 레슨은 여전히 전화나 카톡으로 따로 관리하고 계신 경우가 많습니다
          </p>

          <div className={`${styles.regularLessonContent} ${isVisible3 ? styles.visible : ''}`}>
            <div className={styles.benefitsList}>
              <div className={styles.benefitsHeader}>
                <span className={styles.olympBadge}>올림은 다릅니다</span>
              </div>
              {regularLessonBenefits.map((item, index) => (
                <div
                  key={index}
                  className={styles.benefitItem}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <span className={styles.benefitIcon}>{item.icon}</span>
                  <div className={styles.benefitText}>
                    <h4 className={styles.benefitTitle}>{item.title}</h4>
                    <p className={styles.benefitDesc}>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className={styles.centerShowcase}>
              <div className={styles.centerPhoneMockup}>
                <img src={appPeriodicLessonImage} alt="정기레슨 시간 선택" />
              </div>
              <div className={styles.centerPhoneMockup}>
                <img src={appPeriodicDateSelectImage} alt="정기레슨 날짜 선택" />
              </div>
            </div>
          </div>

          <div className={`${styles.regularLessonConclusion} ${isVisible3 ? styles.visible : ''}`}>
            <p className={styles.conclusionText}>
              이중 관리 없이, <strong>올림 하나로 다 됩니다</strong>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
